<script>
  import { getContext } from "svelte";
  import { fade } from "svelte/transition";
  import { buildSrc, srcSetFromWidths, sizesForBreakpoints } from "$lib/utilities";
  import Markdown from "$lib/components/Markdown.svelte";

  // Deprecated in favor of eagerload
  export const preload = false;

  // Required
  export let asset;
  export let alt;
  export let id;

  // With Defaults
  export let containerClass = "";
  export let containerElement = "figure";
  export let elementClass = "";
  export let caption = "";

  const ariaId = caption ? `img-${id}` : null;
  const childElement = containerElement === "figure" ? "figcaption" : "div";

  export let resizeParams = {};
  export let dimensions = {};

  // Responsive Images flags.
  export let eagerload = false;
  export let responsive = false;

  export let widthsAt;

  // Boolean used to ignore the Contentful Image API image resizing logic
  // Introduced to remove chromatic image flakiness caused by small differences in images
  export let ignoreContentfulImgResize = getContext("ignoreContentfulImgResize");

  // A sensible array of widths for srcset.
  const srcsetWidths = [180, 360, 420, 720, 850, 1250, 1670, 3200];
  $: src = buildSrc(asset, resizeParams, ignoreContentfulImgResize);

  $: srcset =
    responsive && !ignoreContentfulImgResize
      ? srcSetFromWidths(asset?.fields?.file?.url, srcsetWidths, resizeParams)
      : undefined;
  const sizes = responsive ? sizesForBreakpoints(widthsAt) : undefined;
</script>

<svelte:element this={containerElement} class={containerClass} aria-labelledby={ariaId}>
  <img
    class={elementClass}
    {...dimensions}
    {src}
    {srcset}
    {sizes}
    {alt}
    loading={eagerload ? "eager" : "lazy"}
    in:fade
  />
  {#if caption}
    <svelte:element this={childElement} id={ariaId} class="pt-16 lg:pt-32 px-24 lg:px-72">
      <div class="border-l-2 border-neutral-300 pl-24">
        <Markdown input={caption} id="markdown-caption-${id}" />
      </div>
    </svelte:element>
  {/if}
</svelte:element>
